import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-bottom",
  "use": "icon-bottom-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-bottom\"><defs><style></style></defs><path d=\"M512 750.8c-7.2 0-14.4-2.7-19.9-8.2L70.7 321.1c-11-11-11-28.8 0-39.7 11-11 28.8-11 39.7 0L512 683l401.6-401.6c11-11 28.8-11 39.7 0 11 11 11 28.8 0 39.7L531.9 742.6c-5.5 5.5-12.7 8.2-19.9 8.2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol